/**
 * Componente que monta uma tabela com 4 colunas (label, planned, projected, actual).
 * Tem sempre um cabecalho com no formato |    | planned | projected | actual |
 * Sempre mostra o planejado.
 * O projected e o actual são excludentes. Um sera exibido se o outro nao existir.
 *
 * @author: kete@sagaranatech.com
 */


Greenmile.UI = Greenmile.UI || {};
Greenmile.UI.SizesTableView = Greenmile.UI.SizesTableView || {};

Greenmile.UI.SizesTableView = (function () {

    /*
     * informations eh um array de objetos do tipo:
     * label: <primeira coluna>,
     * planned: <plannejado>, projected: <projetado>, actual: <actual>
     */
    function SizesTableView (informations) {
        Greenmile.UI.TimeTableView.apply(this, arguments);

        this.setHeaders([' ',
            Monet.I18n.getResourcesByKey('notificationPanel.planned'),
            Monet.I18n.getResourcesByKey('notificationPanel.actual')]);

        this.generateLines = function () {
            if (informations) {
                for (var i = 0, length = informations.length; i < length; i++) {
                    var info = informations[i];
                    info.projected = (!info.actual ? info.projected : null);
                    info.actual = (!info.projected ? info.actual : null);

                    var line = [new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey(info.label)),
                        new Monet.UI.TableViewCell('TEXT', this.formatSize(info.planned)),
                        new Monet.UI.TableViewCell('TEXT', this.formatSize(info.actual))
                    ];
                    this.addLine(line);
                }
            }
        };

        this.formatSize = function (sizeValue) {
            var value = '.';
            if (sizeValue) {
                value = sizeValue.toFixed(2);
            }
            return value;

        };
    }

    return SizesTableView;

})();

